export default __webpack_public_path__ + "static/media/portrait.53fddce2.webp";